function getSlotText(slot, separator) {
    if (separator === void 0) { separator = ' '; }
    if (!slot || !slot.length)
        return '';
    return slot
        .map(function (vnode) {
        if (Array.isArray(vnode.children) && vnode.children.length) {
            return getSlotText(vnode.children);
        }
        return (vnode.text || '').trim();
    })
        .join(separator)
        .trim();
}

export { getSlotText };
